import { render, staticRenderFns } from "./ui-precision-joystick.vue?vue&type=template&id=fdadfe32&"
import script from "./ui-precision-joystick.vue?vue&type=script&lang=js&"
export * from "./ui-precision-joystick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports